// A quiet callout for the active step's definition of done.
export function DefinitionOfDone({ text }: { text: string }) {
  return (
    <div className="rounded-lg border border-l-4 border-l-primary bg-muted/40 p-4 text-sm leading-relaxed break-words">
      <span className="font-semibold">Definition of done — </span>
      {text}
    </div>
  );
}
